module.exports = __webpack_public_path__ + "img/introduce-cat.d8eb81f8.png";